import { jsx as _jsx } from "react/jsx-runtime";
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './index.css';
const el = document.getElementById('root');
if (!el) {
    throw new Error('Missing #root');
}
createRoot(el).render(_jsx(App, {}));
